import Config from 'netxcore@netx/core-asset/config';
import {isMobile} from '@netx/core/lib/underscore-netx';

Object.assign(Config, {
	DETAIL_TABS: [
		'overview',
		'fileinfo',
		'attributes',
		'attributeHistory',
		'metadata',
		'categories',
		'versions',
		'reviews',
		'views',
		'links',
		'clips',
		'constituents_keyframes',
		'constituents_layers',
		'constituents_pages',
		'permissions',
		'usage',
		'index',
	],
	PAGE_SIZE: 200,
	CHUNK_SIZE: 40,
	EQUAL_GRID: true, // default false
	LIST_TYPE: isMobile()
		? ['card', 'grid']
		: ['card', 'curator', 'grid', 'list'],
	LIST_TYPE_DEFAULT: isMobile() ? 'grid' : 'card',
	// Our theme utilizes asset list layout types
	LIST_TYPES_ENABLED: true,
	CATEGORY_ASSETS_MINI: false,
	SEARCH_ASSETS_MINI: false,
	CART_ASSETS_MINI: false,
	/*
	 * to allow users to define new tags to an attribute of type 'tags', add the attribute's name to tags.flexbile[], like so:
	 */
	tags: {
		flexible: ['add searchable tags'],
	},
	ZOOM_CONTAINER_ID: 'modal',
});

export default Config;
